import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Mail, Globe, Instagram, Facebook, Linkedin } from "lucide-react";

const socials = [
  { icon: Instagram, label: "Instagram", href: "https://instagram.com" },
  { icon: Facebook, label: "Facebook", href: "https://facebook.com" },
  { icon: Linkedin, label: "LinkedIn", href: "https://linkedin.com" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0B281B] text-[#FAFCFA]" data-testid="footer">
      <div className="mx-auto max-w-6xl px-6 py-16 sm:px-12">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo dark />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#98D8BA]">
              We help micro and small businesses look great online — websites,
              Google profiles, branding and more, at prices that make sense.
              Working with clients everywhere, 100% remote.
            </p>
            <div className="mt-6 space-y-2 text-sm text-[#FAFCFA]/80">
              <p className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-[#98D8BA]" /> hello@sprigbuilt.com
              </p>
              <p className="flex items-center gap-2">
                <Globe className="h-4 w-4 text-[#98D8BA]" /> Remote — serving small businesses everywhere
              </p>
            </div>

            <div className="mt-6">
              <p className="text-xs font-bold uppercase tracking-widest text-[#98D8BA]">
                Follow along
              </p>
              <div className="mt-3 flex gap-3" data-testid="footer-socials">
                {socials.map((s) => {
                  const Icon = s.icon;
                  return (
                    <a
                      key={s.label}
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={s.label}
                      data-testid={`social-${s.label.toLowerCase()}`}
                      className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-[#FAFCFA] transition-colors hover:bg-[#98D8BA] hover:text-[#0B281B]"
                    >
                      <Icon className="h-4 w-4" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-[#98D8BA]">
              Explore
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-[#FAFCFA]/80">
              <li><a href="#services" className="hover:text-[#98D8BA]">Services</a></li>
              <li><a href="#pricing" className="hover:text-[#98D8BA]">Pricing</a></li>
              <li><a href="#process" className="hover:text-[#98D8BA]">Process</a></li>
              <li><a href="#work" className="hover:text-[#98D8BA]">Our work</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-[#98D8BA]">
              Get started
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-[#FAFCFA]/80">
              <li><a href="#faq" className="hover:text-[#98D8BA]">FAQ</a></li>
              <li>
                <Link to="/login" className="hover:text-[#98D8BA]" data-testid="footer-admin-link">
                  Admin login
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-[#FAFCFA]/60 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Sprig Built. All rights reserved.</p>
          <p>Built with care for small businesses.</p>
        </div>
      </div>
    </footer>
  );
}
